import { Add, Public } from "@mui/icons-material";
import { Stack } from "@mui/material";
import React, { useState } from "react";
import { useGetList, useTranslate } from "react-admin";
import { DashboardBox } from "../dashboard/DashboardBox";
import { CreateModerableSourceDialog } from "./CreateModerableSourceDialog";
import { ModerableSourceCard } from "./ModerableSourceCard";
import styles from "./ModerableSourceDashboardBox.module.scss";
import type { ModerableSource } from "./moderableSource";

export function ModerableSourceDashboardBox() {
	const translate = useTranslate();
	const { data: sources } = useGetList<ModerableSource>(
		"moderable_sources",
		{},
		{ staleTime: Number.POSITIVE_INFINITY },
	);
	const [isDialogOpen, setDialogOpen] = useState(false);

	const groupedByAccount = sources?.reduce(
		(acc, source, i) => {
			if (source.account_id && source.account_id in acc) {
				acc[source.account_id].push(source);
			} else if (source.account_id) {
				acc[source.account_id] = [source];
			} else {
				acc[i] = [source];
			}

			return acc;
		},
		{} as Record<ModerableSource["account_id"], ModerableSource[]>,
	);

	return (
		<DashboardBox
			title={translate("pos.social_networks.dashboard.sources")}
			icon={Public}
		>
			<Stack height="100%" justifyContent="space-between" gap={1}>
				{groupedByAccount && (
					<Stack gap={1}>
						{Object.entries(groupedByAccount).map(([accountId, sources]) => (
							<ModerableSourceCard
								key={accountId}
								moderableSourceGroup={{
									accountId,
									sources,
									provider: sources[0].provider,
								}}
							/>
						))}
					</Stack>
				)}

				<button
					type="button"
					className={`btn btn-primary ${styles.newSourceBtn}`}
					onClick={() => setDialogOpen(true)}
				>
					<Add /> {translate("pos.social_networks.actions.add_source")}
				</button>
			</Stack>

			<CreateModerableSourceDialog
				open={isDialogOpen}
				handleClose={() => setDialogOpen(false)}
			/>
		</DashboardBox>
	);
}
